import { defineComponent as _defineComponent } from 'vue'
import type { TextRecommendationModuleFragment } from '@/features/onboarded-home/types';

import FadeTransition from '@/components/transitions/FadeTransition.vue';
import TextRecommendationCard from '@/features/why-to-watch/components/TextRecommendationCard.vue';

import { ProfileType } from '@/@types/graphql-types';
import { SnowplowTitleContextGraphql } from '@/helpers/tracking/providers';

import { useTextRecommendation } from '@/helpers/composables/useTextRecommendation';
import { useHomeModuleTracking } from '@/features/onboarded-home/tracking';

import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TextRecommendationModule',
  props: {
    moduleData: null,
    globalPosition: null,
    localPosition: null
  },
  setup(__props: any) {

const props = __props as {
	moduleData: TextRecommendationModuleFragment;
	globalPosition: number;
	localPosition?: number;
};



const { textRecTitle } = useTextRecommendation({ textRecommendation: () => props.moduleData.textRecommendation });

/* TRACKING */
const { moduleContext, moduleObserveVisibility, trackHomeModule } = useHomeModuleTracking({
	moduleData: () => props.moduleData,
	globalPosition: () => props.globalPosition,
	localPosition: () => props.localPosition,
	objectId: () => props.moduleData.textRecommendation.id,
});

const titleContext = computed(() => SnowplowTitleContextGraphql.fromTitle(textRecTitle.value!));

return { __sfc: true,props, textRecTitle, moduleContext, moduleObserveVisibility, trackHomeModule, titleContext, FadeTransition, TextRecommendationCard, ProfileType }
}

})